import { render, staticRenderFns } from "./aed-pendingMoveResend.vue?vue&type=template&id=195e3a76&"
import script from "./aed-pendingMoveResend.vue?vue&type=script&lang=js&"
export * from "./aed-pendingMoveResend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports